import { render, staticRenderFns } from "./suidaoLieBiao.vue?vue&type=template&id=fab3164c&scoped=true"
import script from "./suidaoLieBiao.vue?vue&type=script&lang=js"
export * from "./suidaoLieBiao.vue?vue&type=script&lang=js"
import style0 from "./suidaoLieBiao.vue?vue&type=style&index=0&id=fab3164c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab3164c",
  null
  
)

export default component.exports